import React from "react";
import { DataEntry } from "../../../components/tables/FlexibleTable";
import { Coverage, Provider } from "../../../models/CompanyprofileModels";
import { SBTI_TARGET_STATUS, SBTIColumn } from "./constants";
import { CompassTag } from "../../../components/visuals/CompassTag";

export const mockCoverage: Record<Provider, Coverage> = {
  [Provider.SBTI]: {
    isCovered: false,
    title: "Science Based Targets Initiative",
  },
  [Provider.TPI]: {
    isCovered: false,
    title: "Transition Pathway Initiative",
  },
  [Provider.CA100]: {
    isCovered: false,
    title: "Climate Action 100+ Company",
  },
  [Provider.NZIF]: {
    isCovered: false,
    title: "Net Zero Initiative Framework",
  },
  [Provider.NA100]: {
    isCovered: false,
    title: "Nature Action 100",
  },
};

export const nearTermTableMockData: DataEntry[] = [
  {
    [SBTIColumn.NEAR_TERM_TARGET_STATUS]: (
      <CompassTag {...SBTI_TARGET_STATUS[0]} />
    ),
    [SBTIColumn.TARGET_YEAR]: "2025",
    [SBTIColumn.TARGET_IMPLIED_TEMPERATURE]: "Well Below 2°C",
  },
];

export const longTermTableMockData: DataEntry[] = [
  {
    [SBTIColumn.LONG_TERM_TARGET_STATUS]: (
      <CompassTag {...SBTI_TARGET_STATUS[1]} />
    ),
    [SBTIColumn.TARGET_YEAR]: "2025",
    [SBTIColumn.TARGET_IMPLIED_TEMPERATURE]: "Well Below 2°C",
  },
];

export const netZeroTableMockData: DataEntry[] = [
  {
    [SBTIColumn.NET_ZERO_STATUS]: <CompassTag {...SBTI_TARGET_STATUS[2]} />,
    [SBTIColumn.TARGET_YEAR]: "2025",
  },
];
